import React, { FC, useState, useContext, useEffect, useCallback } from 'react';
import style from './index.module.scss';
import ImageWithFallback from 'src/components/ImageWithFallback';
import { AppContext } from '@utils/browser/app-context';
import thumpImg from '@assets/imgs/default-avatar.svg';
import { Dialog } from '@tencent/calendar-web-component-mobile';
import { logoutPage } from '@model/logout';
import { checkLogin, getUserInfoFromSession, goLogin } from '@utils/login-util';
import { useRouter } from 'next/router';
import NavBanner from '@tencent/tpm-meeting-active/lib/NavBanner';
import '@tencent/tpm-meeting-active/lib/NavBanner/style';
import DefaultAvatar from '@assets/imgs/default-avatar.png';
import { useAccountInfo } from 'src/hooks/useAccount';

interface Params {
  isDisabledLogo?: boolean;
}
const MobileHeader: FC<any> = ({ isDisabledLogo }: Params) => {
  const info = useAccountInfo();
  const { userData } = useContext(AppContext);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [user, setUserData] = useState({
    name: '',
    imageUrl: DefaultAvatar,
    reverse: false,
  });

  const showDialog = useCallback(() => {
    setDialogVisible(true);
  }, []);

  useEffect(() => {
    if (userData?.userid || userData?.app_uid) {
      setUserData({
        ...user,
        imageUrl: info?.avatar || DefaultAvatar,
        name: info?.name || '',
      });
    }
  }, [info]);

  return (
    <>
      <NavBanner
        onLogoClick={() => {
          if (isDisabledLogo) return;
          window.location.href = '/events/square';
        }}
        responsive={true}
        userProps={{
          ...user,
          onClick: showDialog,
          dropdownProps: {
            button: '',
            children: <></>,
            disabled: true,
            trigger: 'click',
          },
        }}
      />
      <UserMenu visible={dialogVisible} onClose={() => setDialogVisible(false)} />
    </>
  );
};

export const UserMenu: FC<{ visible: boolean; onClose(): void }> = ({ visible, onClose }) => {
  const info = useAccountInfo();
  const { userData } = useContext(AppContext);
  const router = useRouter();

  const login = useCallback(() => {
    checkLogin().then((isLogin: boolean) => {
      if (!isLogin) {
        goLogin();
      }
    });
  }, []);

  const toIndex = useCallback(() => {
    router.push('/index');
    onClose();
  }, [onClose]);

  return (
    <Dialog
      title=""
      show={visible}
      hideFooter
      closeOnMaskClick
      onCancel={onClose}
      className={style['user-info-dialog']}
    >
      <ul className={style['menu-list']}>
        <li>
          <ImageWithFallback
            src={info.avatar}
            fallback={thumpImg}
            className={style['info-avatar']}
          />
          {info.name && <div className={style.username}>{info.name}</div>}
        </li>
        {!!userData?.userid && (
          <>
            {router.pathname !== '/home' ? <li onClick={toIndex}>活动空间</li> : null}
            {info.canChangeAccount ? <li onClick={changeAccount}>切换账号</li> : null}
            <li onClick={logout}>退出登录</li>
          </>
        )}
        {!userData?.userid && <li onClick={login}>登录</li>}
        <li onClick={onClose}>取消</li>
      </ul>
    </Dialog>
  );
};

const logout = () => logoutPage('');

const changeAccount = () => {
  const queryObj = new URLSearchParams(location.search);
  queryObj.delete('redirect_link');
  queryObj.delete('redirect_type');
  queryObj.delete('appid');
  queryObj.delete('change-account');
  const redirectLink = encodeURIComponent(`${location.pathname}?${queryObj.toString()}`.slice(1));
  const appId = getUserInfoFromSession()?.app_id;
  sessionStorage.clear();
  window.location.href = `/select-account-type.html?change-account=1&appid=${appId}&redirect_type=2&redirect_link=${redirectLink}`;
};

export default MobileHeader;
